module.exports = {
  siteTitle: 'Gatsby Starter Readonly', // <title>
  manifestName: 'Readonly',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#8470ff',
  manifestThemeColor: '#8470ff',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: ``, // This path is subpath of your hosting https://domain/portfolio
  authorName: 'Davoria Cooper',
  heading: "Future home of Brooklyn Palm",
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/anubhavsrivastava',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/onlyanubhav',
    },
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: 'https://facebook.com/theanubhav',
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:davoria@gmail.com',
    },
  ],
};
